import { ArrowLeft } from "lucide-react";
import { Link, Navigate, useParams } from "react-router-dom";
import { MILESTONE_STATUSES, milestones } from "@/data/milestones";

function StatusBadge({ milestone }) {
  return <span className={`milestone-status milestone-status-${milestone.status}`} data-testid={`milestone-status-${milestone.slug}`}>{MILESTONE_STATUSES[milestone.status].label}</span>;
}

export default function MilestoneDetailPage({ pageMeta }) {
  const { slug } = useParams();
  const milestone = milestones.find((entry) => entry.slug === slug);
  if (!milestone) return <Navigate to="/404" replace />;
  return (
    <main className="milestone-detail-page" data-testid={`milestone-detail-${milestone.slug}`}>
      {pageMeta}
      <section className="milestone-detail-masthead">
        <div className="updates-inner">
          <Link to="/updates" className="updates-back-link" data-testid="back-to-updates-link"><ArrowLeft size={17} aria-hidden="true" /> All Updates</Link>
          <p className="eyebrow eyebrow-amber">Milestone {String(milestone.number).padStart(2, "0")} / {milestones.length}</p>
          <StatusBadge milestone={milestone} />
          {milestone.date && <p className="milestone-detail-date" data-testid="milestone-detail-date">{milestone.date}</p>}
          <h1>{milestone.title}</h1>
        </div>
      </section>
      <article className="milestone-detail-content">
        <div className="updates-inner milestone-detail-copy">
          <p className="milestone-detail-lead">{milestone.fullDescription}</p>
          {milestone.whyItMatters && <section className="milestone-why" aria-labelledby="why-this-matters"><p className="section-label">Why this matters</p><p id="why-this-matters">{milestone.whyItMatters}</p></section>}
          <Link to="/updates" className="updates-back-link updates-back-link-dark" data-testid="detail-back-to-updates-link"><ArrowLeft size={17} aria-hidden="true" /> All Updates</Link>
        </div>
      </article>
    </main>
  );
}